import ReactMarkdown from "react-markdown";

/** Compact Markdown for generated explanations; raw HTML stays disabled. */
export function Markdown({ children }: { children: string }) {
  return (
    <div className="min-w-0 break-words [&_p+p]:mt-2 [&_strong]:font-semibold [&_em]:italic [&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5 [&_li+li]:mt-1 [&_a]:text-link [&_a]:underline [&_blockquote]:my-2 [&_blockquote]:border-l-2 [&_blockquote]:border-line [&_blockquote]:pl-3 [&_pre]:my-2 [&_pre]:overflow-x-auto [&_pre]:rounded [&_pre]:bg-well [&_pre]:p-2 [&_code]:font-mono [&_code]:text-[0.9em] [&_h1]:mt-2 [&_h1]:font-semibold [&_h2]:mt-2 [&_h2]:font-semibold [&_h3]:mt-2 [&_h3]:font-semibold [&_hr]:my-2 [&_hr]:border-line">
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  );
}
